import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";

const CivicUrl = ({ civicUrl }) => {
  return civicUrl ? (
    <div className="varsome-right">
      <small className="tw-mr-4">
        <a href={getVarsoUrl(civicUrl)} target="_blank">
          View this on the CIViC site
        </a>
      </small>
    </div>
  ) : null;
};

CivicUrl.propTypes = {
  civicUrl: PropTypes.string,
};

CivicUrl.defaultProps = {
  civicUrl: null,
};

export default CivicUrl;
